import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Mousewheel, Scrollbar } from "swiper/modules";
import { CraftIdentityContext } from "pages/CraftIdentity";
import CraftIdentityMatchesActions from "./CraftIdentityMatchesActions";
import { getFilteredMatches } from "utils/crafting";
import CraftIdentityMatchItem from "./CraftIdentityMatchItem";

const CraftIdentityMatches = ({ parentSwiper }) => {
  const matchesRef = useRef(null);
  const [sortType, setSortType] = useState("Ready to Craft");
  const [searchMatchesInput, setSearchMatchesInput] = useState("");
  const { matches, isMatchesLoading } = useContext(CraftIdentityContext);

  const stopParent = () => (parentSwiper.current.enabled = false);
  const startParent = () => (parentSwiper.current.enabled = true);
  const updateMatchesRef = () => {
    if (matches.current) {
      matchesRef.current.update();
    }
  };

  const filteredMatches = useMemo(
    () =>
      getFilteredMatches(matches, searchMatchesInput, sortType),
    [matches, searchMatchesInput, sortType]
  );

  useEffect(() => {
    setSearchMatchesInput("");
  }, [matches]);

  useEffect(() => {
    updateMatchesRef();
  }, [filteredMatches]);

  const getComponent = () => {
    if (isMatchesLoading) {
      return (
        <p className="card-details__craft-empty">
          <span className="card-details__craft-empty-loader">
            Loading in process...this may take a moment
          </span>
        </p>
      );
    }

    if (!matches || matches.length === 0) {
      return (
        <p className="card-details__craft-empty">
          {matches === null
            ? "Add at least one date or category to see Identity matches."
            : "No Identity matches"}
        </p>
      );
    }

    return (
      <Swiper
        className="card-details__craft-list-wrapper"
        onSwiper={(swiper) => {
          matchesRef.current = swiper;
        }}
        direction="vertical"
        slidesPerView={"auto"}
        scrollbar={{
          draggable: true,
          snapOnRelease: false,
        }}
        freeMode={true}
        mousewheel={{
          releaseOnEdges: true,
        }}
        modules={[FreeMode, Mousewheel, Scrollbar]}
        onTouchStart={stopParent}
        onTouchEnd={startParent}
      >
        <SwiperSlide>
          <ul className="card-details__craft-list">
            {filteredMatches.map((item) => (
              <CraftIdentityMatchItem
                key={item.id}
                matchesRef={matchesRef}
                item={item}
              />
            ))}
          </ul>
        </SwiperSlide>
      </Swiper>
    );
  };

  return (
    <section
      className={`card-details__card card-details__card--craft-info ${
        filteredMatches.length > 0 ? "card-details__card--loaded" : ""
      }`}
      onMouseEnter={stopParent}
      onMouseLeave={startParent}
    >
      <h3 className="card-details__title">Identity matches</h3>
      <CraftIdentityMatchesActions
        matchesLength={matches.length}
        isMatchesLoading={isMatchesLoading}
        updateMatchesRef={updateMatchesRef}
        searchMatchesInput={searchMatchesInput}
        setSearchMatchesInput={setSearchMatchesInput}
        sortType={sortType}
        setSortType={setSortType}
      />
      {getComponent()}
    </section>
  );
};

export default React.memo(CraftIdentityMatches);

// import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { FreeMode, Mousewheel, Scrollbar } from "swiper/modules";
// import { CraftIdentityContext } from "pages/CraftIdentity";
// import CraftIdentityMatchesDetails from "./CraftIdentityMatchesDetails";
// import CraftIdentityMatchesItemButton from "./CraftIdentityMatchesItemButton";
// import CraftIdentityMatchesActions from "./CraftIdentityMatchesActions";
// import { getFilteredMatches } from "utils/crafting";

// const CraftIdentityMatches = ({ parentSwiper }) => {
//   const matchesRef = useRef(null);
//   const [sortType, setSortType] = useState("Ready to Craft");
//   const [searchMatchesInput, setSearchMatchesInput] = useState("");
//   const { matches, isMatchesLoading } = useContext(CraftIdentityContext);

//   const stopParent = () => (parentSwiper.current.enabled = false);
//   const startParent = () => (parentSwiper.current.enabled = true);
//   const updateMatchesRef = () => {
//     if (matches.current) {
//       matchesRef.current.update();
//     }
//   };

//   const filteredMatches = useMemo(
//     () => getFilteredMatches(matches, searchMatchesInput, sortType, setSortType),
//     [matches, searchMatchesInput, sortType]
//   );

//   const getColor = useCallback((item) => {
//     const data = [
//       item.birth_day.status,
//       item.birth_month.status,
//       item.birth_year.status,
//       item.category.status,
//     ];

//     const filtered = data.filter((status) => status === "Not Owned");

//     if (filtered.length > 2) return "#ffffff";
//     else if (filtered.length === 2) return "#f6360c";
//     else if (filtered.length === 1) return "#f5e417";
//     else return "#06ce22";
//   }, []);

//   const isReadyToCraft = useCallback((item) => {
//     return getColor(item) === "#06ce22";
//   }, [getColor]);

//   useEffect(() => {
//     setSearchMatchesInput("");
//   }, [matches]);

//   useEffect(() => {
//     updateMatchesRef();
//   }, [filteredMatches])

//   const getComponent = () => {
//     if (isMatchesLoading) {
//       return (
//         <p className="card-details__craft-empty">
//           <span className="card-details__craft-empty-loader">
//             Loading in process...this may take a moment
//           </span>
//         </p>
//       );
//     }

//     if (!matches || matches.length === 0) {
//       return (
//         <p className="card-details__craft-empty">
//           {matches === null
//             ? "Add at least one date or category to see Identity matches."
//             : "No Identity matches"
//           }
//         </p>
//       );
//     }

//     return (
//       <Swiper
//         className="card-details__craft-list-wrapper"
//         onSwiper={(swiper) => {
//           matchesRef.current = swiper;
//         }}
//         direction="vertical"
//         slidesPerView={"auto"}
//         scrollbar={{
//           draggable: true,
//           snapOnRelease: false,
//         }}
//         freeMode={true}
//         mousewheel={{
//           releaseOnEdges: true
//         }}
//         modules={[FreeMode, Mousewheel, Scrollbar]}
//         onTouchStart={stopParent}
//         onTouchEnd={startParent}
//       >
//         <SwiperSlide>
//           <ul className="card-details__craft-list">
//             {filteredMatches.map((item) => (
//               <li className="card-details__craft-item">
//                 <CraftIdentityMatchesItemButton
//                   matchesRef={matchesRef}
//                   color={getColor(item)}
//                   variables={[item.custom_one, item.custom_two]}
//                 >
//                   {item.name}
//                 </CraftIdentityMatchesItemButton>
//                 <CraftIdentityMatchesDetails item={item} isReadyToCraft={isReadyToCraft(item)} />
//               </li>
//             ))}
//           </ul>
//         </SwiperSlide>
//       </Swiper>
//     );
//   };

//   return (
//     <section
//       className={`card-details__card card-details__card--craft-info ${filteredMatches.length > 0 ? 'card-details__card--loaded' : ''}`}
//       onMouseEnter={stopParent}
//       onMouseLeave={startParent}
//     >
//       <h3 className="card-details__title">Identity matches</h3>
//       <CraftIdentityMatchesActions
//         matchesLength={matches.length}
//         isMatchesLoading={isMatchesLoading}
//         updateMatchesRef={updateMatchesRef}
//         searchMatchesInput={searchMatchesInput}
//         setSearchMatchesInput={setSearchMatchesInput}
//         sortType={sortType}
//         setSortType={setSortType}
//       />
//       {getComponent()}
//     </section>
//   );
// };

// export default React.memo(CraftIdentityMatches);
